var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMedicalEvaluationCompletedIcon = function SvgMedicalEvaluationCompletedIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79.47,
    height: 71.173,
    viewBox: "0 0 79.47 71.173",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5916",
    "data-name": "Grupo 5916",
    transform: "translate(-782.205 -221.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5911",
    "data-name": "Grupo 5911",
    transform: "translate(792.502 221.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5744",
    "data-name": "Grupo 5744",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5915",
    "data-name": "Grupo 5915"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1697",
    "data-name": "Ret\\xE2ngulo 1697",
    width: 31.851,
    height: 4.826,
    transform: "translate(13.512 33.459)",
    fill: "#1f35b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1698",
    "data-name": "Ret\\xE2ngulo 1698",
    width: 31.851,
    height: 4.826,
    transform: "translate(13.512 20.027)",
    fill: "#1f35b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1699",
    "data-name": "Ret\\xE2ngulo 1699",
    width: 21.797,
    height: 4.826,
    transform: "translate(13.512 46.972)",
    fill: "#1f35b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4403",
    "data-name": "Caminho 4403",
    d: "M53.406,59.841H5.469V11.984H53.406v40.1l3.428-3.428.047-.047,1.995-1.995V11.984a5.4,5.4,0,0,0-1.609-3.9,5.206,5.206,0,0,0-3.861-1.649H37.4A7.766,7.766,0,0,0,34.626,1.81a8.341,8.341,0,0,0-10.376,0,7.766,7.766,0,0,0-2.775,4.625H5.469A5.206,5.206,0,0,0,1.609,8.083,5.4,5.4,0,0,0,0,11.984V59.841a5.357,5.357,0,0,0,1.609,3.941,5.265,5.265,0,0,0,3.861,1.609H53.406a5.265,5.265,0,0,0,3.861-1.609,5.357,5.357,0,0,0,1.609-3.941V48.733L53.406,54.2ZM27.387,5.55a2.82,2.82,0,0,1,4.1,0,2.928,2.928,0,0,1,.845,2.091,2.835,2.835,0,0,1-.845,2.011,2.82,2.82,0,0,1-4.1,0,2.928,2.928,0,0,1-.845-2.091,2.835,2.835,0,0,1,.845-2.011",
    transform: "translate(0 0)",
    fill: "#1f35b5"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_19",
    "data-name": "Subtra\\xE7\\xE3o 19",
    d: "M17.148,33a17.617,17.617,0,0,1-6.675-1.3,17.176,17.176,0,0,1-5.45-3.537,16.436,16.436,0,0,1-3.676-5.245,15.977,15.977,0,0,1,0-12.845A16.4,16.4,0,0,1,5.023,4.832,17.111,17.111,0,0,1,10.474,1.3,17.617,17.617,0,0,1,17.148,0,17.878,17.878,0,0,1,21,.418V32.582A17.79,17.79,0,0,1,17.148,33Z",
    transform: "translate(831.587 259.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1318",
    "data-name": "Grupo 1318",
    transform: "translate(834.683 262.761)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_56",
    "data-name": "Elipse 56",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(-0.094 -0.348)",
    fill: "#4ac326"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2355",
    "data-name": "Caminho 2355",
    d: "M17.317,21.35l-6.491,7.5L6.931,25.533,5.2,27.553l5.914,5.193,8.222-9.665Z",
    transform: "translate(0.872 -13.441)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1992",
    "data-name": "Ret\\xE2ngulo 1992",
    width: 10.25,
    height: 15.717,
    transform: "translate(851.425 236.794)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1993",
    "data-name": "Ret\\xE2ngulo 1993",
    width: 10.25,
    height: 15.717,
    transform: "translate(782.205 236.794)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMedicalEvaluationCompletedIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medical-evaluation-completed-icon.31e7cbee.svg";
export { ForwardRef as ReactComponent };